import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => { api.get(`/blog/${id}`).then((r) => setPost(r.data)).catch(() => {}); }, [id]);

  if (!post) return <div className="container-luxe py-32 text-center text-plumSoft">Loading…</div>;

  return (
    <article data-testid="blog-post" className="section-pad container-luxe max-w-3xl">
      <Link to="/blog" className="text-sm text-plum flex items-center gap-2 mb-8"><ArrowLeft className="w-4 h-4" /> Back to journal</Link>
      <p className="overline">{post.category}</p>
      <h1 className="font-display text-5xl md:text-6xl text-aubergine mt-4 leading-tight">{post.title}</h1>
      <p className="mt-6 text-plum">By {post.author}</p>
      <img src={post.image} alt="" className="rounded-2xl mt-10 w-full h-[480px] object-cover" />
      <div className="mt-10 prose max-w-none text-lg text-plumSoft leading-relaxed font-light">
        <p>{post.excerpt}</p>
        <p className="mt-6">{post.content}</p>
      </div>
    </article>
  );
}
